<template>
  <b-row>
    <b-col cols="12" v-if="isLoading">
      <Loader></Loader>
    </b-col>
    <b-col>
      <table class="table table-sm table-responsive-md table-striped table-hover">
        <thead>
        <tr>
          <th>{{$t('views.userdata.show.userDataFirm.city')}}</th>
          <th>{{$t('views.userdata.show.userDataFirm.street')}}</th>
          <th>{{$t('views.userdata.show.userDataFirm.province')}}</th>
          <th>{{$t('views.userdata.show.userDataFirm.postcode')}}</th>
          <th>{{$t('views.userdata.show.userDataFirm.country')}}</th>
          <th>{{$t('views.userdata.form.addressType')}}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" v-bind:key="'address-' + index">
          <td>{{ item.city }}</td>
          <td>{{ item.street }}</td>
          <td>{{ item.province }}</td>
          <td>{{ item.postcode }}</td>
          <td>{{ item.country }}</td>
          <td>{{ getAddressTypeTitle(item.addressType) }}</td>
          <td>
            <div v-if="ableToEditFirm" class="btn-group float-right">
              <button
                type="button"
                class="btn btn-link fa fa-edit fa-lg"
                @click="updateAddress(item)"
                v-b-tooltip :title="$t('views.userdata.form.editAddress')">
              </button>
              <button
                type="button"
                class="btn btn-link fa fa-trash fa-lg"
                @click="deleteAddress(item)"
                v-b-tooltip :title="$t('views.userdata.form.deleteAddress')">
              </button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <b-row>
        <b-col>
          <b-btn size="sm" v-if="ableToEditFirm" class="btn btn-success" @click="addNewAddress()">{{ $t('views.userdata.form.addNewAddress') }}</b-btn>
        </b-col>
      </b-row>
    </b-col>
    <CreateUserDataAddressModal></CreateUserDataAddressModal>
    <UpdateUserDataAddressModal></UpdateUserDataAddressModal>
  </b-row>
</template>

<script>
import Loader from '@/components/Dashboard/Layout/Loader'
import ApiService from '@/utils/ApiService'
import addParamsToQuery from '@/utils/addParamsToQuery'
import getId from '@/utils/getIdFromLink'
import CreateUserDataAddressModal from '@/components/Dashboard/Views/userdataaddress/components/CreateUserDataAddressModal'
import UpdateUserDataAddressModal from '@/components/Dashboard/Views/userdataaddress/components/UpdateUserDataAddressModal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserDataAddresses',
  props: {
    ableToEditFirm: {
      required: false
    },
    idUserData: {
      required: false
    }
  },
  components: {
    UpdateUserDataAddressModal,
    CreateUserDataAddressModal,
    Loader
  },
  data () {
    return {
      view: {},
      isLoading: true,
      items: [],
      searchParams: {
        idUserData: this.idUserData
      }
    }
  },
  computed: {
    addressUpdated () {
      return this.$store.state.modals.userdataaddress.update.updated
    },
    addressCreated () {
      return this.$store.state.modals.userdataaddress.create.created
    },
    ...mapGetters({
      addressTypeOptions: 'userdataaddress/list/addressTypeOptions',
      getAddressTypeTitle: 'userdataaddress/list/getAddressTypeText'
    })
  },
  watch: {
    addressUpdated: function (change) {
      if (change === 1) {
        this.items = []
        this.getItems()
        this.$store.state.modals.excmagreement.update.updated = 0
      }
    },
    addressCreated: function (change) {
      if (change === 1) {
        this.items = []
        this.getItems()
        this.$store.state.modals.userdataaddress.create.created = 0
      }
    }
  },
  created () {
    this.getItems()
  },
  methods: {
    ...mapActions({
      del: 'userdataaddress/del/del'
    }),
    async getItems () {
      let url = addParamsToQuery('user_data_addresses', { idUserData: getId(this.idUserData) })
      let params = { pagination: false }
      const response = await new ApiService(url, params).getResults()
      this.isLoading = false
      this.items = response.items
      this.view = response.view
    },
    // getAddressTypeTitle (id) {
    //   return this.addressTypeOptions.find(entry => entry.value === id).text
    // },
    addNewAddress () {
      this.$store.state.modals.userdataaddress.create.show = 1
      this.$store.state.modals.userdataaddress.create.userDataIRI = this.idUserData
    },
    updateAddress (item) {
      this.$store.state.modals.userdataaddress.update.userDataAddressPivot = item
      this.$store.state.modals.userdataaddress.update.show = 1
    },
    deleteAddress (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.del(item).then(() => this.getItems())
        this.$Swal({
          title: this.$t('notifications.deletedTitle'),
          type: 'success'
        })
      })
    }
  }
}
</script>
